import { render, staticRenderFns } from "./RecipeTool.vue?vue&type=template&id=edd54cf2&scoped=true"
import script from "./RecipeTool.vue?vue&type=script&setup=true&lang=js"
export * from "./RecipeTool.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RecipeTool.vue?vue&type=style&index=0&id=edd54cf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd54cf2",
  null
  
)

export default component.exports